import React, { Suspense } from 'react'
import { Switch, Route } from 'react-router'
import PageLayout from 'shared/components/Layout/Page'
import { RouteComponentProps, SwitchProps } from 'react-router'
import { Location } from 'history'
import Loader from 'shared/components/Loader'

export interface RouteConfigComponentProps<Params extends { [K in keyof Params]?: string } = {}>
  extends RouteComponentProps<Params> {
  route?: RouteConfig
}

export interface RouteConfig {
  key?: React.Key
  location?: Location
  component?: React.FC<any>
  path?: string | string[]
  exact?: boolean
  strict?: boolean
  routes?: RouteConfig[]
  render?: (props: RouteConfigComponentProps<any>) => React.ReactNode
  [propName: string]: any
}

export default function renderRoutes(
  routes: RouteConfig[] | undefined,
  extraProps = {},
  switchProps: SwitchProps = {},
  isMain = false,
): JSX.Element | null {
  return routes ? (
    <Switch {...switchProps}>
      {routes.map((route: any, i: any) => (
        <Route
          key={route.key || i}
          path={route.path}
          exact={route.exact}
          strict={route.strict}
          render={props => {
            const { pageProps = {}, key } = route
            const {
              pageTitle,
              hasNavigation,
              requireAuth,
              requireWaiver,
              pageId,
              pageDescription,
              requiredRoles,
              permissions,
              isKioskAllowed = false,
              orgTypes = [],
              orgExclusiveTypes = [],
              features,
              level,
            } = pageProps

            const children = (
              <Suspense fallback={<Loader />}>
                <route.component {...props} {...extraProps} route={route} />
              </Suspense>
            )
            if (isMain) {
              return (
                <PageLayout
                  key={key}
                  pageId={pageId || key}
                  pageTitle={pageTitle}
                  hasNavigation={hasNavigation}
                  requireAuth={requireAuth}
                  requireWaiver={requireWaiver}
                  pageDescription={pageDescription}
                  requiredRoles={requiredRoles}
                  permissions={permissions}
                  isKioskAllowed={isKioskAllowed}
                  orgTypes={orgTypes}
                  orgExclusiveTypes={orgExclusiveTypes}
                  features={features}
                  level={level}
                  {...props}
                >
                  {children}
                </PageLayout>
              )
            }
            return children
          }}
        />
      ))}
    </Switch>
  ) : null
}
